import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
// import { FaEye, FaEdit, FaTrash, FaEyeSlash } from "react-icons/fa";
import { FaKey } from "react-icons/fa";

import { useDispatch } from "react-redux";
function UserWiseProductList({ products = [],page,limit }) {
  const navigate = useNavigate();

  return (
    <div>
          <div className="main_page">
        <div className="st-wrapper-card text-center">
          <div className="st-table-responsive">
            <table className="table st-custom-table align-middle mb-0">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Product Name</th>
                  <th>Category</th>
                  <th>SubCategory</th>
                  <th>Stoke</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {products.length > 0 ? (
                  products.map((item, index) => (
                    <tr key={item.id}>
                   <td>{(page - 1) * limit + index + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.category_details?.name || "-"}</td>
                      <td>{item.subcategory_details?.name || "-"}</td>
                      <td></td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No Product Found
                    </td>
                  </tr>
                )}
              </tbody>

            </table>
            {/* {totalPages > 1 && (
              <div className="d-flex justify-content-end mt-3">
                <Pagination
                  page={page}
                  totalPages={totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )} */}
          </div>

        </div>
      </div>

    </div>
  );
}

export default UserWiseProductList;